var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('slice-section-color-block');
import { breakpoints, theme } from '@shapeable/theme';
import { ContentNode } from './content-node';
import { useEntity } from '../hooks/use-entity';
import { useLang } from '../hooks/use-lang';
import { EntityLinkButton } from './entity-link-button';
import { SliceBackgroundColorBlock } from './slice-background-color-block';
import { LinkEntityButton } from './link-entity-button';
export var SliceSectionColorBlockDefaultProps = {
  maxLayoutWidth: '416px'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: inherit;\n    .shp--slice-section-color-block__title + \n    .shp--slice-section-color-block__buttons {\n      margin-top: ", ";\n    }\n\n    a { color: inherit; }\n\n    h1, h2, h3, h4, h5, h6 {\n      font-family: ", "\n    }\n\n    h1, h2, h3, h4, h5, h6, strong, b, em, ul li::before {\n      color: inherit; /* override bullet colors */\n    }\n  "], ["\n    color: inherit;\n    .shp--slice-section-color-block__title + \n    .shp--slice-section-color-block__buttons {\n      margin-top: ", ";\n    }\n\n    a { color: inherit; }\n\n    h1, h2, h3, h4, h5, h6 {\n      font-family: ", "\n    }\n\n    h1, h2, h3, h4, h5, h6, strong, b, em, ul li::before {\n      color: inherit; /* override bullet colors */\n    }\n  "])), theme.UNIT(8), theme.FONT('heading'))
});
var ContainerBodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n    display: flex;\n    align-items: center;\n  "], ["\n    padding: ", ";\n    display: flex;\n    align-items: center;\n  "])), theme.UNIT(6)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme.UNIT(12), theme.UNIT(8))
});
var CommonContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: inherit;\n    font-weight: 300;\n    line-height: 1.5em;\n    color: inherit;\n    margin-top: ", ";\n\n    p:last-child {\n      margin-bottom: 0;\n    }\n  "], ["\n    font-size: inherit;\n    font-weight: 300;\n    line-height: 1.5em;\n    color: inherit;\n    margin-top: ", ";\n\n    p:last-child {\n      margin-bottom: 0;\n    }\n  "])), theme.UNIT(6))
});
var IntroStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), CommonContentStyles)
});
var ContentStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), CommonContentStyles)
});
var LayoutStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    margin: 0 auto;\n    width: 100%;\n    justify-content: center;\n\n  "], ["\n    display: flex;\n    margin: 0 auto;\n    width: 100%;\n    justify-content: center;\n\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 100%;\n    ", "\n  "], ["\n    width: 100%;\n    ", "\n  "])), function (_a) {
    var maxLayoutWidth = _a.maxLayoutWidth;
    return maxLayoutWidth && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      max-width: ", "; \n    "], ["\n      max-width: ", "; \n    "])), maxLayoutWidth);
  })
});
var TitleSizeStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: inherit;\n    font-size: 1.75em; \n    line-height: 1.15em;\n    font-weight: 500;\n    align-items: center;\n    margin-top: 0;\n    margin-bottom: 0;\n    display: flex;\n  "], ["\n    color: inherit;\n    font-size: 1.75em; \n    line-height: 1.15em;\n    font-weight: 500;\n    align-items: center;\n    margin-top: 0;\n    margin-bottom: 0;\n    display: flex;\n  "]))),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: 2em; \n  "], ["\n    font-size: 2em; \n  "]))),
  desktop: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    font-size: 2.25em; \n  "], ["\n    font-size: 2.25em; \n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    font-weight: 500;\n    ", ";\n  "], ["\n    font-weight: 500;\n    ", ";\n  "])), TitleSizeStyles),
  tablet: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: ", ";\n  "])), theme.UNIT(4))
});
var ButtonInnerStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme.UNIT(4))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    width: auto;\n    margin-top: ", ";\n  "], ["\n    width: auto;\n    margin-top: ", ";\n  "])), theme.UNIT(4))
});
var LinkStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ButtonStyles)
});
var PageLinkStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ButtonStyles)
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    ", ";\n    font-weight: 300;\n  "], ["\n    ", ";\n    font-weight: 300;\n  "])), TitleSizeStyles)
});
// -------- Components -------->
var My = {
  Container: styled(SliceBackgroundColorBlock)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled.h2.attrs(cls.attr('title'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled.h3.attrs(cls.attr('subtitle'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Intro: styled(ContentNode)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Content: styled(ContentNode)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Buttons: styled.div.attrs(cls.attr('buttons'))(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  PageLink: styled(EntityLinkButton)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), PageLinkStyles),
  LinkButton: styled(LinkEntityButton)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var SliceSectionColorBlock = function (props) {
  var className = props.className,
    children = props.children,
    isReversed = props.isReversed,
    aspectRatio = props.aspectRatio,
    preBody = props.preBody,
    preTitle = props.preTitle,
    backgroundColor = props.backgroundColor,
    imageBackgroundColor = props.imageBackgroundColor,
    maxLayoutWidth = props.maxLayoutWidth;
  var entity = useEntity(props.entity);
  var title = entity.title,
    subtitle = entity.subtitle,
    intro = entity.intro,
    content = entity.content,
    _a = entity.links,
    links = _a === void 0 ? [] : _a,
    _b = entity.pages,
    pages = _b === void 0 ? [] : _b;
  var t = useLang();
  // console.log(props);
  return React.createElement(My.Container, {
    imageBackgroundColor: imageBackgroundColor,
    backgroundColor: backgroundColor,
    isReversed: isReversed,
    entity: entity,
    bodyStyles: ContainerBodyStyles,
    aspectRatio: aspectRatio,
    className: cls.name(className)
  }, React.createElement(My.Layout, {
    maxLayoutWidth: maxLayoutWidth
  }, preBody, React.createElement(My.Body, {
    maxLayoutWidth: maxLayoutWidth
  }, title && React.createElement(My.Title, null, preTitle, title), subtitle && React.createElement(My.Subtitle, null, subtitle), React.createElement(My.Intro, {
    entity: intro
  }), React.createElement(My.Content, {
    entity: content
  }), React.createElement(My.Buttons, null, links.map(function (link) {
    return React.createElement(My.LinkButton, {
      key: link.id,
      entity: link
    });
  })))));
};
SliceSectionColorBlock.defaultProps = SliceSectionColorBlockDefaultProps;
SliceSectionColorBlock.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31;